import callApi from "../utils/callApi";
import { ServiceUrl } from "../utils/serviceUrl";

export const _LIST_SETTINGS = async (searchData = false) => {
  let url = ServiceUrl.LIST_SETTINGS;
  return callApi(url, "post", searchData && searchData);
};
